import { range } from 'lodash-es';

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const years = range(1990, new Date().getFullYear() + 2, 1);

export const YEAR_OPTIONS = years.map((y) => ({
  value: y.toString(),
  label: y,
}));
